import { HttpParams } from '@angular/common/http'
import { Params } from '@angular/router'

export class ApiUtils {
  public static buildQueryString(obj: {}): string {
    let query: string = ''

    Object.entries(obj).forEach(([key, value], index, arr) => {
      query += `${key}=${value}`
      if (index !== arr.length - 1) query += '&'
    })

    return query
  }

  public static buildHttpParams(obj: Params): HttpParams {
    let httpParams = new HttpParams()
    Object.entries(obj).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        httpParams = httpParams.set(key, value.join(','))
      } else if (value !== undefined && value !== null && !(typeof value === 'string' && value.trim() === '')) {
        httpParams = httpParams.set(key, value.toString())
      }
    })
    return httpParams
  }
}
